export const badgeColorByStatusText = (status_text?: string) => {
  switch (status_text) {
    case 'Pengajuan Amandemen':
    case 'Amandemen':
    case 'Diamandemen Customer':
    case 'Telah Diamandemen':
      return 'badge-light-info'
    case 'Expired':
      return 'badge-light-danger'
    default:
      return 'badge-light-danger'
  }
}
